import { distance as levenshteinDistance } from 'fastest-levenshtein'

/**
 * Calculate Levenshtein ratio (0-1 scale) between two strings.
 *
 * @see location-matching-algorithm.md#levenshtein-ratio
 */
export function levenshteinRatio(a: string, b: string): number {
  if (a === b) return 1.0
  if (a.length === 0 || b.length === 0) return 0.0

  const dist = levenshteinDistance(a, b)
  const maxLen = Math.max(a.length, b.length)
  return 1 - (dist / maxLen)
}
